// 📁 File: src/context/LanguageContext.js
import { createContext, useState, useEffect, useContext } from 'react';
import i18n from '../i18n';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('lang') || i18n.language || 'en');

  const changeLanguage = (newLang) => {
    i18n.changeLanguage(newLang);
    localStorage.setItem('lang', newLang);
    setLang(newLang);
  };

  useEffect(() => {
    if (typeof i18n?.on === 'function') {
      const onLangChange = (lng) => setLang(lng);
      i18n.on('languageChanged', onLangChange);
      return () => {
        if (typeof i18n.off === 'function') {
          i18n.off('languageChanged', onLangChange);
        }
      };
    }
  }, []);
  

  return (
    <LanguageContext.Provider value={{ lang, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);